<template>
    <div
        :class="{
            darkblue: activeStep >= number,
            gray: activeStep < number || final,
        }"
        class="font16 marginbottom20 pointer numberHeaderContainer"
        style="line-height: 25px; margin-right: 12px; display: flex;flex-flow:column"
    >

        <div
            :class="{
                 darkblue: activeStep >= number,
                gray: activeStep < number || final,
            }"
            class="numberHeaderSubtitle"
        >
            <b>{{ title }}</b
            >
        </div>
      <span style="margin-top:10px;"> {{ subtitle }}</span>

    </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import {
    faArrowDown,
    faCheck,
    faSpinner,
} from '@fortawesome/free-solid-svg-icons'

library.add(faSpinner)
library.add(faArrowDown)
library.add(faCheck)

export default {
    name: 'NumberHeader',
    props: {
        number: Number,
        title: String,
        subtitle: String,
        loading: Boolean,
        activeStep: Number,
        final: Boolean,
    },
}
</script>

<style lang="scss" scoped>
.numberHeaderContainer {

  > span {
    color: #7f8386 !important;
    font-size: 14px !important;
    width:100%;
    background-color: transparent !important;
  }
    .numberHeader {
        display: block;
        border-radius: 50%;
        color: #fff;
        height: 25px;
        width: 25px;
        text-align: center;
        font-weight: bold;
        font-size: 16px;
        right: 10px;
        top: 10px;
        float: left;
        margin-right: 8px;
        line-height: 25px;
    }

    .numberHeaderSubtitle {
        max-width: 90%;
        display: inline-block;
      font-size:22px;
      line-height:24px;
    }

    .darkblueBullet {
        color: #ffffff;
        background-color: #2078b3 !important;
    }
}
</style>
